import { Divider } from '@heroui/react';
import { BaseProperty } from '@trwl/backend.api';

import { DescriptionItem } from './DesctiptionItem';

export const Description = ({
  baseProperties,
  description,
}: {
  baseProperties?: BaseProperty[];
  description?: string;
}) => {
  if ((baseProperties?.length ?? 0) === 0 && (description?.length ?? 0) === 0)
    return null;
  return (
    <div>
      <div className="text-[#282828] text-[20px] font-[500]">Описание</div>
      {baseProperties && baseProperties.length > 0 && (
        <div className="text-[14px] mt-[10px] text-black font-[300] w-full">
          {baseProperties.map((baseProperty) => (
            <DescriptionItem
              key={baseProperty.basePropertyKeyId}
              propertyKey={baseProperty.basePropertyKey}
              propertyValue={baseProperty.basePropertyValue}
            />
          ))}
        </div>
      )}
      {description && description.length > 0 && (
        <>
          <Divider className="my-4 max-w-xl" />
          <div className="text-[14px] mt-[10px] text-black font-[300] w-full max-w-xl">
            {description.split('\n').map((line, idx, arr) => (
              <span key={idx}>
                {line}
                {idx < arr.length - 1 && <br />}
              </span>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
